import type { NodeTrackingPayload } from '@getaccept/lib-shared/src/tracking/types/node-tracking-payload';
import { TrackingType } from '@getaccept/lib-shared/src/tracking/types/tracking-type';
import type { NodeIds, NodeTracking, NodeVisibilityPayload } from '../types/node-tracking';

export class NodeTrackingHelper {
  static isIdsInTrackings(node: NodeIds, trackings: NodeTracking[]): boolean {
    return trackings.some((trackingNode: NodeTracking) => this.isSame(node, trackingNode));
  }

  static isSame(firstIds: NodeIds, secondIds: NodeIds): boolean {
    return (
      firstIds.sectionId == secondIds.sectionId &&
      firstIds.rowId == secondIds.rowId &&
      firstIds.cellId == secondIds.cellId &&
      firstIds.nodeId == secondIds.nodeId
    );
  }

  static convertToTracking({
    nodeId,
    cellId,
    rowId,
    sectionId,
    editorBlockId,
  }: NodeVisibilityPayload): NodeTracking {
    return {
      nodeId,
      cellId,
      rowId,
      editorBlockId,
      sectionId,
      timeSpent: 0,
      visible: true,
    };
  }

  static convertToTrackingPayload(
    nodeTrackings: NodeTracking[],
    revision: number
  ): NodeTrackingPayload[] {
    return nodeTrackings.map(
      ({ nodeId, cellId, rowId, sectionId, editorBlockId, timeSpent }: NodeTracking) => ({
        nodeId,
        cellId,
        rowId,
        sectionId,
        editorBlockId,
        timeSpent,
        revision,
        type: TrackingType.NodeTimeSpent,
      })
    );
  }
}
